import { gql } from '@apollo/client';

export const GET_USER_PERMISSIONS = gql`
  query GetUserPermissions {
    user {
      notificationPreferences {
        dailyPricingReportPortfolioCodes
      }
      permissions {
        pledging
        pledgeAndRelease
        muniCredit
        apm
        files
        cds
      }
      portfolios {
        institutionId
        portfolioCode
        portfolioId
        portfolioName
      }
    }
  }
`;
